<template>
  <div class="rounded-lg border p-4 mt-12 relative" id="checkout-wizard">
    <div class="flex flex-row justify-center items-center -mt-10 text-xs text-center mb-4">
      <div
        id="step-indicator-1"
        class="step-indicator"
        @click="selectStep(1)"
        :class="currentStep > 1 ? 'completed' : currentStep == 1 ? 'current' : '' ">
        <div class="step-number">1</div>
        <p>Tus datos</p>
      </div>
      <div
        id="step-indicator-2"
        class="step-indicator"
        @click="selectStep(2)"
        :class="currentStep > 2 ? 'completed' : currentStep == 2 ? 'current' : '' ">
        <div class="step-number">2</div>
        <p>Despacho</p>
      </div>
      <div
        id="step-indicator-3"
        class="step-indicator"
        @click="selectStep(3)"
        :class="currentStep == 3 ? 'current' : '' ">
        <div class="step-number">3</div>
        <p>Pago</p>
      </div>
    </div>

    <div key="step1" v-show="currentStep == 1">
      <slot name="step1"></slot>
      <div class="text-center"><button type="button" class="bt main" @click="goToStep(2)">Continuar</button></div>
    </div>
    <div key="step2" v-show="currentStep == 2">
      <slot name="step2"></slot>
      <div class="text-center"><button type="button" class="bt main" @click="goToStep(3)">Continuar</button></div>
    </div>
    <div key="step3" v-show="currentStep == 3">
      <slot name="step3"></slot>
    </div>

  </div>
</template>
<script>
export default {
  name: 'checkout-wizard',
  data() {
    return {
      currentStep: 1,
      CustomError : ''
    }
  },
  methods: {
    selectStep(newStep) {
      if (newStep < this.currentStep) {
        this.currentStep = newStep;
      }
    },
    goToStep(step) {
      let isValid = true;
      let fields = [];

      if (step == 2) {
        fields = [
          'billing_first_name',
          'billing_last_name',
          'billing_phone',
          'billing_email',
          'billing_address',
          'billing_country_id',
          'billing_state_id',
          'billing_city_id',
        ];
      } else {
        let delivery_value = document.querySelector('[name="delivery_type"]').value;

        if (delivery_value == 'SHIPPING') {
          fields = [
            'shipping_name',
            'shipping_dui',
            //'shipping_nit',
            'shipping_phone',
            'shipping_address',
            'shipping_state_id',
            'shipping_city_id',
          ];
        } else if (delivery_value == 'PICKUP') {
          fields = ['pickup_store_id'];
        } else if (delivery_value == 'MULTIPLE') {
          fields = [
            'pickup_store_id',
            'shipping_name',
            'shipping_dui',
            //'shipping_nit',
            'shipping_address',
            'shipping_phone',
            'shipping_state_id',
            'shipping_city_id',
          ];
        }else{
          fields = ['delivery_type'];
        }
      }

      if (!this.validateRequiredFields(fields)) {
        isValid = false;
      }

      if (isValid) {
        this.currentStep = step;
      } else {
        alert(this.CustomError);
      }
    },
    validateRequiredFields(fields) {
      this.CustomError = 'Por favor, completa correctamente el formulario';
      let output = true;
      fields.forEach(field => {
        if (!document.querySelector(`[name="${field}"]`).value) {
          output = false;
        }
      });

      if (document.getElementById('products-not-apply')){ 
        let liNot = document.getElementById('products-not-apply').querySelectorAll('li');
        let cartProducts = document.getElementsByClassName('product-detail');
        let deliveryTypeValue = document.getElementById('delivery_type').value

        if ( (liNot.length != cartProducts.length) && deliveryTypeValue !="MULTIPLE" ) {
          output = false;
          this.CustomError = 'Selecciona ambas formas de entrega si comprará todos los productos.';
        }else if ( (liNot.length == cartProducts.length) && deliveryTypeValue !="PICKUP" ) {
          output = false;
          this.CustomError = 'Selecciona únicamente retiro en tienda';
        }
      }

      return output;
    }
  }
}
</script> 